import BaseButton from './components/BaseButton';
import CopyButton from './components/CopyButton';

const Button = BaseButton;

Button.Copy = CopyButton;

export { Button };
